<template>
  <v-container>
    <v-layout
      row
      pt-10
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <h2
          class="primary--text"
        >
          Recommended Classes for {{ currentBalletClass.title }}
        </h2>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex
        xs12
      >
        <form @submit.prevent="onUpdateRecommendations">
          <v-layout
            row
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
            </v-flex>
          </v-layout>
          <v-layout
            row
            pt-3
          >
          </v-layout>
          <v-layout
            row
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-text-field
                id="classUrl"
                v-model="classUrl"
                name="classUrl"
                label="On-Demand URL for this Class"
                required
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            pt-5
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-btn
                class="primary"
                :disabled="!formIsValid"
                type="submit"
              >
                Save
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    props: ['id'],
    data () {
      return {
        title: '',
        classUrl: ''
      }
    },
    computed: {
      currentBalletClass () {
        return this.$store.getters.currentBalletClass
      },
      formIsValid () {
        return this.classUrl !== ''
      }
    },
    created () {
      this.$store.dispatch('loadBalletClass', this.id).then(() => {
        this.title = this.currentBalletClass.title
      })
      this.$store.dispatch('loadBalletClassRecommendations', this.id).then(() => {
        if (this.currentBalletClassRecommendations !== null) {
          this.classUrl = this.currentBalletClassRecommendations.classUrl
        }
      })
    },
    methods: {
      onUpdateRecommendations () {
        if (!this.formIsValid) {
          return
        }
        this.$store.dispatch('updateBalletClassRecommendations', {
          id: this.id,
          classUrl: this.classUrl
        }).then(() => {
          this.$router.push('/ballet-classes/recommendations/' + this.id)
        })
      }
    }
  }
</script>
